import { render, staticRenderFns } from "./OrdenesCompraList.vue?vue&type=template&id=4d158c69"
import script from "./OrdenesCompraList.vue?vue&type=script&lang=js"
export * from "./OrdenesCompraList.vue?vue&type=script&lang=js"
import style0 from "./OrdenesCompraList.vue?vue&type=style&index=0&id=4d158c69&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports